import { atom } from 'nanostores';

// Initialize the store with the theme from localStorage or default to 'light'
export const themeStore = atom<string>(
  typeof window !== 'undefined'
    ? localStorage.getItem('theme') ?? 'light'
    : 'light',
);

// Function to update the theme in localStorage and synchronize it across tabs
themeStore.subscribe((theme: any) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }
});
